import { z } from "zod";

export const loginSchema = z.object({
  email: z.string().email(),
  password: z.string().min(8),
});

export type Login = z.infer<typeof loginSchema>;

export const loginResSchema = z.object({
  user: z.object({
    name: z.string(),
    role: z.number(),
  }),
  token: z.string(),
});

export type LoginRes = z.infer<typeof loginResSchema>;
